module.exports = __webpack_public_path__ + "resource/img/points.4bcfba06.svg";